module.exports = __webpack_public_path__ + "img/au.ac7ddaca.svg";